import { CircularProgress, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import ReactPlayer from 'react-player';
import { FaceResult } from './AIResult/FaceResult';

export function Video({ video, model1Result }) {
  return (
    <>
      <Stack spacing={3}>
        {video ? (
          video.length === 0 ? ( //the video is being loaded
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress color="inherit" />
              <Typography>Video is downloading</Typography>
            </Box>
          ) : (
            <Box>
              <ReactPlayer style={{ margin: 'auto' }} height="450px" width="795px" controls={true} url={video} />
            </Box>
          )
        ) : null}

        {model1Result ? <FaceResult model1Result={model1Result} title="FAST AI Score" /> : null}
      </Stack>
    </>
  );
}
